import React, {FC} from 'react';
import {useTranslation, WidgetProps} from '@wix/yoshi-flow-editor';
import {ControllerContext} from './ControllerContext';
import {PoliciesControllerContext} from './PoliciesControllerContext';
import {CheckoutControllerProps, PoliciesControllerProps} from '../../../types/checkoutApp.types';
import {LocaleKeysProvider} from '../../../locale-keys/LocaleKeys';
import CheckoutApp from '../CheckoutApp/CheckoutApp';
import PoliciesPage from '../PoliciesPage/PoliciesPage';
import {withSlotsPlaceholders} from '@wix/widget-plugins-ooi';
import {FormViewerContext} from '@wix/form-viewer/widget';
import {withExpressCheckoutButtons} from '@wix/ecom-platform-express-checkout-buttons/widget';
import {withPaymentsApi} from '../../../common/components/WithPaymentsApi/WithPaymentsApi';
import {withFunctionObservationResult} from '@wix/function-result-observation';
import {withDeliverySection} from '@wix/delivery-section-checkout/controller';
import {useComposerListener} from '../Hooks/useComposerListener';
import './index.css';

type WidgetControllerProps = WidgetProps<CheckoutControllerProps> | WidgetProps<PoliciesControllerProps>;

const CheckoutWidget: FC<WidgetProps<CheckoutControllerProps>> = (controllerProps) => {
  const {t} = useTranslation();

  useComposerListener(controllerProps);

  return (
    <ControllerContext value={controllerProps}>
      <LocaleKeysProvider
        translateFn={(key: any, options: any, ...rest: unknown[]) =>
          t(key, {...options, interpolation: {escapeValue: false}, ...rest})
        }>
        <FormViewerContext {...controllerProps}>
          <CheckoutApp />
        </FormViewerContext>
      </LocaleKeysProvider>
    </ControllerContext>
  );
};

const PoliciesPageWidget: FC<WidgetProps<PoliciesControllerProps>> = (controllerProps) => {
  const {t} = useTranslation();

  return (
    <PoliciesControllerContext value={controllerProps}>
      <LocaleKeysProvider
        translateFn={(key: any, options: any, ...rest: unknown[]) =>
          t(key, {...options, interpolation: {escapeValue: false}, ...rest})
        }>
        <PoliciesPage />
      </LocaleKeysProvider>
    </PoliciesControllerContext>
  );
};

const WrappedCheckoutWidget = withFunctionObservationResult(
  withPaymentsApi(withExpressCheckoutButtons(withSlotsPlaceholders(withDeliverySection(CheckoutWidget))))
);

const Widget: FC<WidgetControllerProps> = (controllerProps) => {
  if (controllerProps?.isPoliciesPage) {
    return <PoliciesPageWidget {...controllerProps} />;
  }

  return <WrappedCheckoutWidget {...(controllerProps as WidgetProps<CheckoutControllerProps>)} />;
};

export default Widget;
